// extracted by mini-css-extract-plugin
export default {"timeline":"lsf-timeline","timeline__topbar":"lsf-timeline__topbar","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630385600
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  